// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn_close[data-v-cd15a9a4] {\n  width: 1.3rem;\n  height: 1.3rem;\n  position: absolute;\n  top: -0.3rem;\n  right: -2.3rem;\n}", ""]);
// Exports
module.exports = exports;
